import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import { menuInfo } from "@shared/type/CommonType";
import SnForm from "@widgets/SnForm";
import { showDialog } from "@widgets/CommonDialog";

interface Props {
  Menuprops: menuInfo;
}

// 암호보안정책관리
const SN_MAS_SET_REG_010 = forwardRef(({ Menuprops }: Props, ref) => {
  const { userInfo, config } = global();

  const formRef = React.createRef<any>();

  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [formData, setFormData] = useState<any>();
  const [initFlag, setInitFlag] = useState<boolean>(true);

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormData(rtn.formData);

        const formCtrlData = rtn.form.freeform1.map((item: any) => {
          if (
            item.cd_param &&
            config &&
            Object.prototype.hasOwnProperty.call(config, item.cd_param)
          ) {
            return {
              ...item,
              nm_label: config[item.cd_param]?.nm_ctrl ?? item.nm_label,
            };
          }
          return item;
        });
        setFormControlData(formCtrlData);
        setInitFlag(true);
      } catch (error) {}
    };
    fetchform();
  }, []);

  useEffect(() => {
    if (initFlag) {
      onSearch();
      setInitFlag(false);
    }
  }, [initFlag]);

  const onSearch = async () => {
    try {
      const modifiedFormData = formRef.current.getChange();
      if (modifiedFormData.modifiedRowcount > 0) {
        const confirm = await showDialog(
          "confirmCancel",
          "수정된 내용이 있습니다. 저장하시겠습니까?"
        );
        if (confirm) {
          const isSaved: any = await onSave();
          if (!isSaved) return;
        } else if (confirm === undefined) {
          return;
        }
      }

      const param = {
        id: "sn_mas_set_reg_010_01",
        params: {},
      };
      const data: any = await fnGetDataSet(param);
      const upperData = (data[0] ?? []).map((row: any) =>
        Object.fromEntries(
          Object.entries(row).map(([key, value]) => [key.toUpperCase(), value])
        )
      );
      setFormData(upperData[0]);
    } catch (error) {}
  };

  const onSave = async () => {
    const formData = formRef.current.getChange();

    const row = formData.update[0];
    formData.update = Object.entries(row)
      .filter(([key]) => key.startsWith("SYS"))
      .map(([key, value]) => ({
        cd_firm: row.CD_FIRM,
        cd_module: "SYS",
        cd_ctrl: key,
        dc_ctrl: value,
      }));
    const saveData = {
      config: formData,
    };
    const isSaved = await fnSave("SN_MAS_SET_REG_010_SAVE_01", saveData);
    if (isSaved) formRef.current.resetUpdate();
  };

  useImperativeHandle(ref, () => ({
    onSearch,
    onSave,
  }));

  return (
    <SnForm
      ref={formRef}
      data={formData}
      controls={formControlData}
      etcProps={{ labelSize: 270 }}
    />
  );
});

export default SN_MAS_SET_REG_010;
